import { render, staticRenderFns } from "./incl-newsletterList-recipients.vue?vue&type=template&id=5dd66efc&scoped=true"
import script from "./incl-newsletterList-recipients.vue?vue&type=script&lang=js"
export * from "./incl-newsletterList-recipients.vue?vue&type=script&lang=js"
import style0 from "./incl-newsletterList-recipients.vue?vue&type=style&index=0&id=5dd66efc&prod&lang=scss&scoped=true"
import style1 from "./incl-newsletterList-recipients.vue?vue&type=style&index=1&id=5dd66efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd66efc",
  null
  
)

export default component.exports